module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-loader"
  }, [_c('ui-progress-circular', {
    attrs: {
      "show": true,
      "type": "indeterminate",
      "size": 40
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72a550e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageLoader.vue
// module id = 303
// module chunks = 2